import React from "react";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { observer, inject } from "mobx-react";

import { Values } from "Tools/Values";
import { STFormWrapper } from "@src/Components/Ui/STFormWrapper";
import renderCommonFormField from "@src/Components/Common/FormFields/renderCommonFormField";
import FormSwitch from "@src/Components/Common/FormFields/FormSwitch/FormSwitch";
import { IValuesStore } from "@src/Stores/Values/types";
import { Grid } from "@material-ui/core";
import { IManagementStore } from "@src/Stores/Management/types";
import { PermissionGroup } from "@src/Interfaces/Entity/PermissionGroup";
import { STFormTitleTypography } from "@src/Components/Ui/STFormTitleTypohraphy";
import { ButtonsForm } from "@src/Components/Common/ButtonsForm/ButtonsForm";
import TransferList from "@src/Components/Common/TransferList/TransferList";
import { computed } from "mobx";
import { STGrid } from "./styles";
import { STContentWrapper } from "@src/Components/Common/SimpleModal/styles";
import {IAuthStore} from "Stores/Auth/types";

const organisationsSchema = Yup.object().shape({
  name: Yup.string().required(() => {
    return Values.getLocalizationValue("fieldRequired");
  }),
  permissions: Yup.array()
    .of(Yup.string())
    .required(() => {
      return Values.getLocalizationValue("fieldContain");
    }),
});

interface IProps {
  title: string;
  initialValues: PermissionGroup;
  onSubmit: (values: PermissionGroup) => void;
  onClose: () => void;
  values?: IValuesStore;
  management?: IManagementStore;
  auth?: IAuthStore;
}

@inject("values", "management", "auth")
@observer
class PermissionGroupForm extends React.Component<IProps> {
  @computed get selectedPermissions() {
    let permissions = this.props.initialValues.permissions
      .map((permission: string) => {
        return this.props.management.activePermissions.find(_ => _.id === permission);
      })
      .filter(item => item);
    if (!this.props.auth.isAdmin) {
      permissions = permissions.filter(x => x.id != this.props.values.common["AdminPermissionId"]);
    }
    return permissions;
  }
  
  @computed get availablePermissions() {
    if (this.props.auth.isAdmin) {
      return this.props.management.activePermissions;
    }
    return this.props.management.activePermissions.filter(x => x.id != this.props.values.common["AdminPermissionId"]);
  }
  
  render() {
    return (
      <Formik
        initialValues={this.props.initialValues}
        validationSchema={organisationsSchema}
        onSubmit={this.props.onSubmit}
        render={(formikProps: FormikProps<PermissionGroup>) => (
          <STFormWrapper onSubmit={formikProps.handleSubmit}>
            <STFormTitleTypography>{this.props.title}</STFormTitleTypography>
            <STContentWrapper>
              <Grid container>
                <Grid item xs={6}>
                  {renderCommonFormField<PermissionGroup>("name", Values.getLocalizationValue("name"), formikProps)}
                </Grid>
                <Grid item xs={8}>
                  {renderCommonFormField<PermissionGroup>(
                    "description",
                    Values.getLocalizationValue("description"),
                    formikProps
                  )}
                </Grid>
              </Grid>

              <STGrid container spacing={16} justify="flex-start" alignItems="center" zeroMinWidth>
                <Grid item>{Values.getLocalizationValue("active")}</Grid>
                <Grid item>
                  <FormSwitch<PermissionGroup>
                    trueAs={this.props.values.states.Active}
                    falseAs={this.props.values.states.Deactivated}
                    fieldName="state"
                    formikProps={formikProps}
                  />
                </Grid>
              </STGrid>

              <TransferList
                fieldName="permissions"
                label={Values.getLocalizationValue("permissions")}
                formikProps={formikProps}
                allItems={this.availablePermissions}
                selectedItems={this.selectedPermissions}
                keyAsValue="id"
                keyAsTitle="name"
              />
            </STContentWrapper>
            <ButtonsForm onSubmit={formikProps.handleSubmit} onClose={this.props.onClose} />
          </STFormWrapper>
        )}
      />
    );
  }
}

export default PermissionGroupForm;
